// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"daa2321a","191":"daa2321a","545":"daa2321a","549":"daa2321a"}[chunkId] + ".chunk.css";
};